export default (function (siteVariables) {
  return {
    avatarBorderColor: '',
    avatarBorderWidth: '0',
    statusBorderColor: siteVariables.bodyBackground,
    statusBorderWidth: '2px'
  };
});